<template>
  <v-container fluid>
    <v-card elevation="0" flat>
      <v-toolbar color="#eeeeee" tile flat dense>
        <h3 class="title"></h3>
        <v-spacer />
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              :to="`/biddings-items/create/${bidding_id}`"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Adicionar</span>
        </v-tooltip>
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="showSearch = !showSearch"
            >
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </template>
          <span>Pesquisar</span>
        </v-tooltip>
        <v-footer absolute color="primary" dark v-if="showSearch">
          <v-text-field
            class="search-field"
            v-model="search"
            color="#fff"
            placeholder="pesquisar"
            prepend-inner-icon="mdi-magnify"
            append-outer-icon="mdi-close"
            @click:append-outer="[(showSearch = !showSearch), (search = '')]"
          />
        </v-footer>
      </v-toolbar>

      <v-card-actions>
        <v-data-table
          :headers="headers"
          :items="data"
          :search="search"
          :items-per-page="8"
          :loading="loader"
          loading-text="CARREGANDO..."
          class="elevation-0 maxPage"
        >
          <template v-slot:item.item_price="{ item }">
            <span>{{ realMaskII(item.item_price.toFixed(3)) }}</span>
          </template>
          <template v-slot:item.item_billing_price="{ item }">
            <span>{{ realMaskII(item.item_billing_price.toFixed(3)) }}</span>
          </template>
          <template v-slot:item.item_status="{ item }">
            <span>{{ item.item_status ? "SIM" : "NÃO" }}</span>
          </template>
          <template v-slot:item.item_status_retroactive="{ item }">
            <span>{{ item.item_status_retroactive ? "SIM" : "NÃO" }}</span>
          </template>
          <template v-slot:item.item_amount="{ item }">
            <span>{{ realMask(item.item_amount.toFixed(2)) }}</span>
          </template>
          <template v-slot:item.action="{ item }">
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  class="mr-2"
                  @click="
                    $router.push(
                      `/biddings-items/edit/${item.item_id}/${bidding_id}`
                    )
                  "
                  color="primary"
                  >mdi-pencil</v-icon
                >
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom color="error">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  class="mr-2"
                  @click="deleteItem(item.item_id)"
                  color="error"
                  >mdi-delete</v-icon
                >
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-actions>
    </v-card>
    <v-snackbar
      multi-line
      :color="snack.color"
      v-model="snack.show"
      transition="fade-transition"
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Helpers from "@/mixins/helpers.js";
export default {
  props: ["bidding_id"],
  mixins: [Helpers],
  data() {
    return {
      search: "",
      loader: true,
      showSearch: false,
      data: [],
      snack: {
        show: false,
        message: "",
        color: "",
      },
      headers: [
        {
          text: "Número",
          align: "start",
          sortable: false,
          value: "item_number",
        },
        { text: "Descrição", value: "item_description_desc" },
        { text: "Participante", value: "provider_name" },
        { text: "Prc Unitário", value: "item_price" },
        { text: "Prc Lic Total", value: "item_billing_price" },
        { text: "Quantidade", value: "item_amount" },
        { text: "Quant. Disp", value: "item_available" },
        { text: "Status", value: "item_status" },
        { text: "Status Retroactive", value: "item_status_retroactive" },
        { text: "Ações", align: "right", value: "action", sortable: false },
      ],
    };
  },
  created() {
    this.initialize();
    this.Helpers;
  },
  methods: {
    initialize() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/biddings/items/${this.bidding_id}`)
        .then((r) => {
          this.data = r.data;
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    deleteItem(id) {
      let c = confirm("Deseja excluir o registro?");
      if (c) {
        this.$store.dispatch("setLoader", true);
        this.$http
          .delete(`/biddings/items/${id}`)
          .then((r) => {
            if (r.data.success) {
              this.snack.show = true;
              this.snack.message = r.data.success;
              this.snack.color = "success";
            } else {
              this.snack.show = true;
              this.snack.message = r.data.error;
              this.snack.color = "error";
            }
            this.initialize();
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.$store.dispatch("setLoader", false);
          });
      }
    },
  },
};
</script>

<style scoped>
.top-bar {
  padding: 30px 15px;
}
.title {
  text-transform: uppercase;
  font-weight: 400;
}
.maxPage {
  width: 100%;
}
.search-field {
  margin-top: 10px;
}
.space {
  margin: 0 10px;
}
</style>